import { default as UploadEPrescription } from './upload-e-prescription';

export default {
  UploadEPrescription,
}